import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { sendChangeUserData } from '../services/send-change-user-data.service';
import { SendChangeUserDataPostParams } from '../services/@types/send-change-user-data.types';

interface EditProfile {
  loading: boolean;
  error: {
    message: string;
    isVisible: boolean;
  };
  isEditing: boolean;
  isOpenSuccessModal: boolean;
  isOpenConfirmCancel: boolean;
}

const initialState: EditProfile = {
  loading: false,
  error: {
    isVisible: false,
    message: '',
  },
  isEditing: false,
  isOpenSuccessModal: false,
  isOpenConfirmCancel: false,
};

export const requestUserChangeData = createAsyncThunk(
  'user/change-data',
  async (params: SendChangeUserDataPostParams, { rejectWithValue }) => {
    try {
      await sendChangeUserData(params);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

const editProfile = createSlice({
  name: 'edit-profile',
  initialState,
  reducers: {
    closeApiErrorModal(state) {
      state.error = {
        isVisible: false,
        message: '',
      };
    },
    closeSuccessModal(state) {
      state.isOpenSuccessModal = false;
    },
    openConfirmCancel(state) {
      state.isOpenConfirmCancel = true;
    },
    closeConfirmCancel(state) {
      state.isOpenConfirmCancel = false;
    },
    setIsEditing(state, action: PayloadAction<boolean>) {
      state.isEditing = action.payload;
    },
  },

  extraReducers(builder) {
    builder.addCase(requestUserChangeData.pending, state => {
      state.loading = true;
    });
    builder.addCase(requestUserChangeData.fulfilled, state => {
      state.loading = false;
      state.isOpenSuccessModal = true;
    });
    builder.addCase(requestUserChangeData.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = {
        message: payload as string,
        isVisible: true,
      };
    });
  },
});

export const {
  closeApiErrorModal,
  closeSuccessModal,
  closeConfirmCancel,
  openConfirmCancel,
  setIsEditing,
} = editProfile.actions;

export default editProfile.reducer;
